import APIconsume from './../APIconsume'
import LoginService from "../LoginService"

class DashboardService extends LoginService {
    constructor() {
        super()
        this._url = 'Customer'
        this._consume = new APIconsume()
    }

    async loadDashboard () {
        const url = ''
        const result = await this._consume.getData(url)
        return result.data
    }

    async postQris (trxId) {
        const url = '/payment/qris'
        const payload = {
            trxId
        }
        const result = await this._consume.postData(payload, url)
        return result.data
    }

    async getQrisState (trxId) {
        const url = '/payment/qris?trxId=' + trxId
        const result = await this._consume.getData(url)
        return result.data
    }
}


export default DashboardService;